import { LicensingAgencyStatus } from '@/@types/generated'
import format from '@/lib/format'
import { LicensingAgencyStatusTextColor } from '@/lib/format/LicensingAgencyStatus'
import { cn } from '@/lib/utils'

export function LicensingAgencyStatusBadge({
  status,
}: {
  status: LicensingAgencyStatus
}) {
  return (
    <div className="flex items-center gap-0.5">
      <span
        className={cn(
          'relative h-4 text-4xl leading-3',
          LicensingAgencyStatusTextColor[status]
        )}
      >
        &bull;
      </span>
      <span>{format.Enum(LicensingAgencyStatus, status)}</span>
    </div>
  )
}
